import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import doorSliding from '../../src/image/door-sliding.jpg';
import doorHinged from '../../src/image/door-hinged.jpg';
import Breadcrumbs from './Breadcrumbs';
import './theme.css';

function MosquitoNetDoors() {
    const [activeTab, setActiveTab] = useState('sliding');

    useEffect(() => { AOS.init({ duration: 1000, once: true }); }, []);

    const keyFeatures = {
        sliding: [
            { icon: 'bi-check-circle-fill', desc: 'The pleated net folds neatly and expands smoothly, offering a visually appealing texture that blends beautifully with home interiors.' },
            { icon: 'bi-check-circle-fill', desc: 'Designed with a friction-less track system, the door operates with a gentle push, making it comfortable for children, elders and heavy-use environments.' },
            { icon: 'bi-check-circle-fill', desc: 'The foldable mesh occupies minimal space when opened, making it ideal for narrow passages, large door frames and modern interiors.' },
            { icon: 'bi-check-circle-fill', desc: 'Best Suitable for Main doors, Balcony entrances, French doors, Patio openings and Large window frames.' },
        ],
        hinged: [
            { icon: 'bi-check-circle-fill', desc: 'Heavy-Duty Aluminium Construction.This door offers exceptional rigidity and strength—ideal for main entrances with frequent usage.' },
            { icon: 'bi-check-circle-fill', desc: 'The door closes smoothly and automatically, ensuring complete insect protection without noise or manual effort..' },
            { icon: 'bi-check-circle-fill', desc: 'The integrated Weather Strip around the frame seals gaps effectively, keeping out dust, insects, and tiny pests—ideal for all seasons.' },
            { icon: 'bi-check-circle-fill', desc: 'Designed to blend beautifully with wooden, UPVC, or aluminium main doors without affecting appearance or space.' },
        ],
    };

    const benefits = {
        sliding: [
            { icon: 'bi-check-circle-fill', desc: 'Modern and premium appearance.' },
            { icon: 'bi-check-circle-fill', desc: 'Glide-open design for effortless use.' },
            { icon: 'bi-check-circle-fill', desc: 'Ideal for wide entrances.' },
            { icon: 'bi-check-circle-fill', desc: 'Enhances ventilation without compromising safety.' },
            { icon: 'bi-check-circle-fill', desc: 'Best Suited For, Apartments & villas, Living room entrances, Balcony and sit-out areas and Homes with decorative main doors.' },
        ],
        hinged: [
            { icon: 'bi-check-circle-fill', desc: 'Engineered for heavy daily use.' },
            { icon: 'bi-check-circle-fill', desc: 'Long-lasting and rust-proof components.' },
            { icon: 'bi-check-circle-fill', desc: 'High ventilation with zero insect entry.' },
            { icon: 'bi-check-circle-fill', desc: 'Perfect for apartments, villas, and independent houses.' },
            { icon: 'bi-check-circle-fill', desc: 'Best Suited For, Main entrance doors, Balcony and patio entry points, High-usage areas needing strong and elegant mosquito protection' },
        ],
    };


    return (
         <div className="container-fluid p-0 ">
            <Header />

            <section className="theme-section">
                <Breadcrumbs/>
                <div className="container" data-aos="fade-up">
                    <div className="theme-section-title text-center">
                        <h2>Mosquito Net Doors</h2>
                        <p>At Indec Decors, we manufacture premium mosquito-net door systems designed to provide long-lasting protection,
                            smooth operation, and a clean, modern appearance. Our doors are made using high-quality aluminium profiles,
                            stainless-steel nets, and precision-fitted accessories to ensure durability and ease of use.</p>
                    </div>

                    {/* Tabs */}
                    <div className="theme-tabs" data-aos="fade-up" data-aos-delay="100">
                        {['sliding', 'hinged'].map(tab => (
                            <div
                                key={tab}
                                className={`theme-tab-link ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab === 'sliding' ? 'Sliding / Pleated Door' : 'Classic / Premium Magnetic Main Door'}
                            </div>
                        ))}
                    </div>

                    {/* Tab Content */}
                    <div className="theme-row" data-aos="fade-up">
                        {activeTab === 'sliding'
                            ?
                            <div>
                                <p>Our Pleated Mosquito Net Door System is designed for homeowners who want a smooth, elegant and modern insect-control solution.
                                    Unlike traditional mesh doors, the pleated system uses a foldable mesh that glides effortlessly from side to side, making it the
                                    perfect choice for main entrances, balconies, and large openings.</p>
                                <p>With its sleek design, easy operation and durable components, this door combines aesthetics with
                                    functionality—allowing fresh air to flow in while keeping mosquitoes, flies and other insects out.</p>
                            </div>
                            :
                            <div>
                                <p>Our Main Door Mosquito Net System is specially designed for entrance doors that require a robust, high-performance, and premium-looking mosquito protection solution.
                                    Built using heavy-grade aluminium channels and upgraded accessories, this door ensures long-lasting durability and seamless daily usage.</p>
                                <p>This mosquito net door offers maximum airflow while keeping insects out—perfect for homes that value hygiene, ventilation, and aesthetics.</p>
                            </div>
                        }
                        <div className="col-lg-6 theme-col">
                            <h6>Key Features</h6>
                            <ul className="theme-features">
                                {keyFeatures[activeTab].map((item, index) => (
                                    <li key={index}>
                                        <i className={`bi ${item.icon}`}></i>{item.desc}
                                    </li>
                                ))}
                            </ul>

                            <h6>Benefits</h6>
                            <ul className="theme-features">
                                {benefits[activeTab].map((item, index) => (
                                    <li key={index}>
                                        <i className={`bi ${item.icon}`}></i>{item.desc}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="col-lg-6 theme-col theme-image-wrapper" data-aos="zoom-in">
                            <img
                                src={activeTab === 'sliding' ? doorSliding : doorHinged}
                                alt="Mosquito Net Door"
                                className="theme-image"
                            />
                        </div>
                    </div>

                    <div className='theme-row' data-aos="fade-up">
  <div className="theme-col">
    <h6>Types of Operations</h6>
    <p className='muted small'>
      Built with high-quality materials to ensure durability, smooth operation and premium finish.
    </p>

    <div className="fabric-list">

      <div className="decs">
        <i className="bi-check-circle-fill" style={{ marginRight: "6px", color: "var(--accent)" ,fontSize:"13px"}}></i>
        <span style={{ fontWeight: 600, fontSize: "13px" }}>Single Opening Door :</span><p style={{fontSize:"13px"}}> A Single Opening Main Door features one operable shutter that opens either inward or outward.</p>
      </div>

      <div className="desc" >
        <i className="bi bi-check-circle-fill" style={{ marginRight: "6px",fontSize:"13px", color: "var(--accent)" }}></i>
       <span style={{ fontWeight: 600, fontSize: "13px" }}>Double Opening Main Door :</span> <p style={{fontSize:"13px"}}>A Double Opening Main Door (2-leaf / double shutter) uses two shutters — one fixed/semi-fixed and one operable, or both operable depending on the design.</p>
      </div>

    </div>
  </div>
</div>

<div className='theme-row' data-aos="fade-up">
  <div className="theme-col">
    <h6>Types of Doors We Make</h6>
    <div className="fabric-list">

        <div className="decs">
        <i className="bi-check-circle-fill" style={{ marginRight: "6px", color: "var(--accent)" ,fontSize:"13px"}}></i>
        <span style={{ fontWeight: 600, fontSize: "13px" }}>Classic Doors :</span><p style={{fontSize:"13px"}}> A classic mosquito net door for entrance is a hinged door fitted with a fine mesh that allows fresh air and light to pass through while effectively blocking mosquitoes, insects, and dust, providing a simple and durable protection solution for main doorways.</p>
      </div>

      <div className="decs">
        <i className="bi-check-circle-fill" style={{ marginRight: "6px", color: "var(--accent)" ,fontSize:"13px"}}></i>
        <span style={{ fontWeight: 600, fontSize: "13px" }}>Plain Pleated Doors :</span><p style={{fontSize:"13px"}}> Standard retractable pleated mesh doors designed for everyday insect protection with simple functionality and cost efficiency.</p>
      </div>

      <div className="decs">
        <i className="bi-check-circle-fill" style={{ marginRight: "6px", color: "var(--accent)" ,fontSize:"13px"}}></i>
        <span style={{ fontWeight: 600, fontSize: "13px" }}>Personalized Pleated Doors :</span><p style={{fontSize:"13px"}}> Custom-designed pleated doors tailored in size, 
            color, mesh type, and finish to match specific interior aesthetics and user preferences.</p>
      </div>

      <div className="desc" >
        <i className="bi bi-check-circle-fill" style={{ marginRight: "6px",fontSize:"13px", color: "var(--accent)" }}></i>
       <span style={{ fontWeight: 600, fontSize: "13px" }}>Pleated Barrier Free Doors :</span> <p style={{fontSize:"13px"}}> Bottom-track-free pleated doors that provide seamless, obstruction-free movement.</p>
      </div>

      <div className="desc" >
        <i className="bi bi-check-circle-fill" style={{ marginRight: "6px",fontSize:"13px", color: "var(--accent)" }}></i>
       <span style={{ fontWeight: 600, fontSize: "13px" }}>Security Pleated Doors :</span> <p style={{fontSize:"13px"}}> Reinforced pleated doors with high-strength mesh and locking systems, offering both ventilation and enhanced safety against intrusion.</p>
      </div>

      <div className="desc" >
        <i className="bi bi-check-circle-fill" style={{ marginRight: "6px",fontSize:"13px", color: "var(--accent)" }}></i>
       <span style={{ fontWeight: 600, fontSize: "13px" }}>Honeycomb Partition/Pleated Doors :</span> <p style={{fontSize:"13px"}}> Honeycomb structured pleated doors that act as space partitions 
        while providing insulation, privacy, modern aesthetics. Used to divide rooms, section off areas (like kitchens or balconies), and provide insulation against heat and insects.</p>
      </div>

    </div>
  </div>
</div>



                    <div className='theme-row' data-aos="fade-up">
                        <div className="theme-col">
                            <h6>Materials Used</h6>
                            <p className='muted small'>Built with high-quality components to ensure durability, strength and low maintenance.</p>
                            {
                                activeTab === 'sliding'
                                    ?
                                    <div className="fabric-list">
                                        <div className="chip">Aluminium Channel</div>
                                        <div className="chip">Pleated Mesh</div>
                                        <div className="chip">Security Mesh</div>
                                        <div className="chip">Honeycomb Mesh</div>
                                        <div className="chip">Handle</div>
                                        <div className="chip">Thread</div>
                                        <div className="chip">Pulling Bar</div>
                                    </div>
                                    :
                                    <div className="fabric-list">
                                        <div className="chip">Aluminium Channel</div>
                                        <div className="chip">SS Net</div>
                                        <div className="chip">Heel</div>
                                        <div className="chip">Hinges</div>
                                        <div className="chip">Handle</div>
                                        <div className="chip">Magnetic Strip</div>
                                        <div className="chip">Weather Strip</div>
                                    </div>
                            }
                        </div>
                    </div>

                    {/* Feature Boxes */}
                    <div className="row theme-feature-section">
                        <div className="theme-feature-box">
                            {activeTab === 'sliding'
                                ? <p className="theme-feature-description">“Experience premium comfort and elegant protection—choose our Pleated Mosquito Net Door for a stylish, breathable and insect-free home.”</p>
                                :
                                <p className="theme-feature-description">“Protect your home effortlessly with a door that blends strength, style, and smart mosquito control.”</p>
                            }
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default MosquitoNetDoors;
